// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qrBtn[data-v-3d0fa60b]{border-radius:4px!important;-webkit-box-shadow:4px 3px 5px rgba(2,16,92,.3);box-shadow:4px 3px 5px rgba(2,16,92,.3);cursor:pointer;-webkit-transition:all .15s ease-in-out;transition:all .15s ease-in-out}.qrBtn[data-v-3d0fa60b]:hover{border-radius:8px!important;-webkit-box-shadow:8px 5px 10px rgba(2,16,92,.5490196078431373)!important;box-shadow:8px 5px 10px rgba(2,16,92,.5490196078431373)!important}.hasBorder[data-v-3d0fa60b]{border:2px solid green}", ""]);
// Exports
module.exports = exports;
